import React from 'react';
import AdvancedHostingPageContent from './AdvancedHostingPageContent';

const AdvancedHostingPage = () => (
  <div data-testid="contentWrapper">
    <AdvancedHostingPageContent />
  </div>
);

export default AdvancedHostingPage;
